import { render } from "./ConnectWallet.vue?vue&type=template&id=2535f9a6&scoped=true"
import script from "./ConnectWallet.vue?vue&type=script&lang=js"
export * from "./ConnectWallet.vue?vue&type=script&lang=js"

import "./ConnectWallet.vue?vue&type=style&index=0&id=2535f9a6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2535f9a6"]])

export default __exports__